import { SEO } from 'components/SEO';

import AccountCreatingStep from './AccountCreatingStep';

const Onboarding = () => {
  return (
    <>
      <SEO
        title="BigDevSoon | Onboarding"
        description="Onboarding page"
        url={`${process.env.REACT_APP_SITE_URL}onboarding`}
      />
      <AccountCreatingStep />
    </>
  );
};

export default Onboarding;
